var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.chargingTypeList.length > 0
    ? _c(
        "div",
        { staticClass: "filter-inline" },
        [
          _c(
            "form-group",
            {
              staticClass: "service-box",
              attrs: { name: "service", label: _vm.name },
            },
            [
              _c("md-input", {
                attrs: { type: "hidden" },
                model: {
                  value: _vm.selectedOption,
                  callback: function ($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption",
                },
              }),
              _c("vue-select", {
                attrs: {
                  "data-testid": "service-package",
                  reduce: function (r) {
                    return r
                  },
                  label: "rateGroupName",
                  options: _vm.chargingTypeList,
                  searchable: _vm.$root.isDesktop,
                  placeholder: _vm.placeHolderLabel,
                },
                model: {
                  value: _vm.selectedOption,
                  callback: function ($$v) {
                    _vm.selectedOption = $$v
                  },
                  expression: "selectedOption",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }